import React, { Fragment } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { translate } from '../../../utils/locale';
import s from './BenefitCard.scss';


const Benefits = ({ content, setup }) => (
	<>
		<h2 className={s.benefits_cardTitle}>{ translate(setup, content.cardTitle) }</h2>
		<ul className={s.benefits_benefitsList}>
			{
				content.benefitsIndex && content.benefitsIndex.map((item) => (
					<li key={translate(setup, item.item)}>{ translate(setup, item.item) }</li>
				))
			}
		</ul>
		<div className={s.benefits_heroIngredients}>
			<h3 className={s.benefits_heroIngredientsTitle}>{ translate(setup, content.heroIngredientsTitle) }</h3>
			{
				content.ingredients && content.ingredients.map((item) => (
					<Fragment key={translate(setup, item.ingredient)}>
						<p className={s.benefits_ingredient}>{ translate(setup, item.ingredient) }</p>
						<p className={s.benefits_benefit}>{ translate(setup, item.benefit) }</p>
					</Fragment>
				))
			}
		</div>
		<h3 className={s.benefits_tipTitle}>{ translate(setup, content.tipTitle) }</h3>
		<p className={s.benefits_tipContent} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, content.tipContent)) }} />
	</>
);
export default hot(module)(Benefits);
